// extracted by mini-css-extract-plugin
module.exports = {"textarea":"a10a3f92e9--textarea--xowv8"};